import React from 'react';
import { useTranslation } from 'react-i18next';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Typography from '@material-ui/core/Typography';
import cn from 'classnames';
import PropTypes from 'prop-types';
import MainButton from '../../../components/MUI/MainButton';
import OfferInfo from './OfferInfo';
import useRegisterValidationFields from '../../../hooks/useRegisterValidationFields';

import useStyles from './makeStyles';

const AddNewMemberButton = ({ handleAddNewMember, setValue, register }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  useRegisterValidationFields(['isChild', 'isPerson', 'isParent'], register);

  return (
    <div className={classes.container}>
      <MainButton
        variant="outlined"
        color="primary"
        className={cn(classes.button, classes.addChildrenButton)}
        onClick={() => {
          setValue('isChild', true);
          setValue('isPerson', false);
          setValue('isParent', false);
          handleAddNewMember({
            isChild: true,
            isPerson: false,
            isParent: false,
          });
        }}
      >
        <div className={classes.offerInfoBox}>
          <OfferInfo />
          <div className={classes.description}>
            <div className={classes.descriptionHead}>
              <AddCircleOutlineIcon className={classes.icon} />
              <Typography color="primary" className={classes.addMemberText}>
                {t('oncoCareContract.addNewChild')}
              </Typography>
            </div>
            <Typography color="primary" className={classes.addNewChildInfo}>
              {t('oncoCareContract.addNewChildInfo')}
            </Typography>
          </div>
        </div>
      </MainButton>

      <MainButton
        variant="outlined"
        color="primary"
        className={classes.button}
        onClick={() => {
          setValue('isChild', false);
          setValue('isPerson', true);
          setValue('isParent', false);
          handleAddNewMember({ isChild: false, isPerson: true, isParent: false });
        }}
      >
        <AddCircleOutlineIcon className={classes.icon} />
        <Typography color="primary" className={classes.addMemberText}>
          {t('oncoCareContract.addNewInsuredPerson')}
        </Typography>
      </MainButton>
    </div>
  );
};

AddNewMemberButton.propTypes = {
  handleAddNewMember: PropTypes.func,
  setValue: PropTypes.func,
  register: PropTypes.func,
};

AddNewMemberButton.defaultProps = {
  handleAddNewMember: () => {},
  setValue: () => {},
  register: () => {},
};

export default AddNewMemberButton;
